import type { FaireProductEntity } from "../../entity_types/product";

export const p_z5da6fe2ew: FaireProductEntity = {
  token: "p_z5da6fe2ew",
  type: "product",
  name: "Rectangular Enamel Tray - Ace of Hearts",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl: "https://cdn.faire.com/fastly/f459964472bdcd962533c261e614c813924055d334c3f9f7a0855bc55ff674ea.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/653f3fa3bf7ffa5a65b41bc105d76c15f08179c4f0f5eae5ee129f0a86691afc.jpeg",
    "https://cdn.faire.com/fastly/1d92aacd7ce098ba352bbfaeb717694dc4b03d7ef2df0be199d5d28fc73bb411.jpeg"
  ],
  priceDollars: 10.5,
  description: "Bring a playful sense of nostalgia to the home with this Ace of Hearts Rounded Rectangle Enamel Tray. Inspired by vintage playing cards and antique gaming ephemera, the design features the classic ace of hearts motif framed by a rich burgundy and black checkerboard border, combining bold graphic pattern with timeless character.\n\nHandcrafted by skilled artisans in India, each tray includes subtle variations and finishing marks that celebrate the beauty of traditional craftsmanship. The tray is finished with a contrasting gold-coloured underside for an added decorative detail.\n\nPerfect for holding jewellery, watches, coins, or small everyday objects, this enamel catchall tray is both practical and decorative — a versatile piece designed for bedside tables, desks, dressing tables, and shelves.\n\nSize: H 15.5cm x W 11.6cm / H 6.1\" x W 4.6\"\n*Each of our enamel trays is expertly handcrafted in India. Due to the nature of this handmade production process, please expect some variation in the final product.",
  tags: [],
  msrpDollars: 23,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:42.435Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
